/**
 * This bridge is used to capture and store message from Antd App.useApp().
 * Needed when we are calling Antd 'message' outside of React components or Hooks (example messageUtils used in graphql.js)
 */

let messageApi = null;

export function setAntdMessageApi(api) {
  messageApi = api;
}

export function getAntdMessageApi() {
  return messageApi;
}
